import React from 'react';
import { Button } from 'antd';
import { ToolOutlined, InboxOutlined } from '@ant-design/icons';

const MaintenancePage = ({ message = 'We are currently under maintenance. Please check back later.' }) => {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #FF6B00 0%, #FF9F1C 100%)',
      padding: '20px'
    }}>
      <div style={{
        background: '#fff',
        borderRadius: '24px',
        padding: '60px 40px',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        maxWidth: '500px',
        width: '100%'
      }}>
        <div style={{
          fontSize: '100px',
          color: '#FF6B00',
          marginBottom: '24px',
          animation: 'float 3s ease-in-out infinite'
        }}>
          <InboxOutlined />
        </div>
        
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#1a1a2e',
          marginBottom: '16px',
          fontFamily: '"Poppins", "Segoe UI", "Roboto", sans-serif'
        }}>
          System Maintenance
        </h1>
        
        <p style={{
          fontSize: '16px',
          color: '#666',
          lineHeight: '1.6',
          marginBottom: '32px',
          fontFamily: '"Poppins", "Segoe UI", "Roboto", sans-serif'
        }}>
          {message}
        </p>
        
        <Button 
          type="primary" 
          size="large"
          icon={<ToolOutlined />}
          onClick={() => window.location.reload()}
          style={{
            height: '48px',
            paddingLeft: '32px',
            paddingRight: '32px',
            fontSize: '16px',
            fontWeight: '600',
            borderRadius: '24px',
            background: 'linear-gradient(135deg, #FF6B00 0%, #FF9F1C 100%)',
            border: 'none',
            boxShadow: '0 4px 15px rgba(255, 107, 0, 0.4)'
          }}
        >
          Refresh Page
        </Button>
        
        <div style={{
          marginTop: '40px',
          paddingTop: '24px',
          borderTop: '1px solid #eee'
        }}>
          <p style={{
            fontSize: '14px',
            color: '#999',
            fontFamily: '"Poppins", "Segoe UI", "Roboto", sans-serif'
          }}>
            We'll be back soon!
          </p>
        </div>
      </div>
      
      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }
      `}</style>
    </div>
  );
};

export default MaintenancePage;
